/**
 * /claim/confirm/:token — public email-confirmation gate for
 * "Claim or Confirm This Profile" submissions.
 */
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api, { fmtErr } from "../api";
import { useI18n } from "../i18n";
import useNoIndex from "../useNoIndex";

export default function ClaimConfirm() {
  useNoIndex();
  const { token } = useParams();
  const { lang } = useI18n();
  const es = lang === "es";
  const [state, setState] = useState({ loading: true });

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/claims/confirm/${token}`);
        setState({ loading: false, ok: true, ref: data.reference_id, already: data.already_confirmed });
      } catch (e) {
        setState({
          loading: false, ok: false,
          expired: e.response?.status === 410,
          msg: fmtErr(e.response?.data?.detail) || e.message,
        });
      }
    })();
  }, [token]);

  return (
    <div className="container-cd py-20 max-w-2xl" data-testid="claim-confirm-page">
      {state.loading ? (
        <div className="overline">{es ? "Confirmando…" : "Confirming…"}</div>
      ) : state.ok ? (
        <div className="cd-card p-10 text-center" data-testid="claim-confirm-success">
          <div className="overline" style={{ color: "var(--orange)" }}>
            {es ? "REFERENCIA" : "REFERENCE"} · <span data-testid="claim-confirm-ref">{state.ref}</span>
          </div>
          <h1 className="font-display text-4xl mt-4">
            {state.already
              ? es ? "Ya estaba confirmado." : "Already confirmed."
              : es ? "Correo confirmado." : "Email confirmed."}
          </h1>
          <p className="mt-4 text-sm" style={{ color: "var(--ink-2)" }}>
            {es
              ? "Tu envío entró a la cola de revisión del equipo de Corridor Digital."
              : "Your submission has entered the Corridor Digital review queue."}
          </p>
          <p className="mt-3 font-mono text-xs" style={{ color: "var(--ink-2)" }} data-testid="claim-confirm-no-status-note">
            {es ? "Esto no cambia el estatus de tu listado." : "This does not change your listing's status."}
          </p>
          <Link to="/plants" className="btn btn-ghost mt-6">
            {es ? "Volver al directorio" : "Back to the directory"}
          </Link>
        </div>
      ) : (
        <div className="cd-card p-10 text-center" data-testid="claim-confirm-error">
          <h1 className="font-display text-4xl">
            {state.expired
              ? es ? "Enlace expirado." : "Link expired."
              : es ? "Enlace inválido." : "Invalid link."}
          </h1>
          <p className="mt-4 text-sm" style={{ color: "var(--ink-2)" }}>
            {state.expired
              ? es
                ? "El enlace era válido 7 días. Puedes enviar el formulario de nuevo desde el perfil de tu planta."
                : "The link was valid for 7 days. You can submit the form again from your plant profile."
              : state.msg}
          </p>
        </div>
      )}
    </div>
  );
}
